// The stored CouponStatus numbers (data/enums.js CouponStatus).
export const CAMPAIGN_STATUS = { draft: 0, scheduled: 1, active: 2, paused: 3, disabled: 4, archived: 5 };

// Spec §2.2: Active = 0–4, Archived = 5.
export const ACTIVE_FILTER_STATUSES = [0, 1, 2, 3, 4];
export const ARCHIVED_FILTER_STATUSES = [5];

// Spec §2.2's tag table. Scheduled and Paused are never written by this
// dashboard and read as Inactive. Tones are FinBadge's: `available` is the
// green pair (#E3F5EA/#15803D), `canceled` the neutral one (#EEF1F6/#3C4A68).
export const statusTag = (status) => {
  if (status === CAMPAIGN_STATUS.active) return { label: 'Active', tone: 'available' };
  if (status === CAMPAIGN_STATUS.draft) return { label: 'Draft', tone: 'canceled' };
  if (status === CAMPAIGN_STATUS.archived) return { label: 'Archived', tone: 'canceled' };
  return { label: 'Inactive', tone: 'canceled' };
};

// Spec §2.5: Active (2) shows the switch on; 1/3/4 show it off. On writes
// 2, off writes 4 (D2 opens 4 → 2).
export const switchOn = (status) => status === CAMPAIGN_STATUS.active;
export const statusAfterSwitch = (on) => (on ? CAMPAIGN_STATUS.active : CAMPAIGN_STATUS.disabled);

// The legacy card's Active / Expired (spec §2.3), read from `expiredate`
// exactly as today's list does: expired unless it ends after now.
export const legacyStatusTag = (expiredate, now = new Date()) => {
  const ends = expiredate ? new Date(expiredate).getTime() : NaN;
  return ends > now.getTime() ? { label: 'Active', tone: 'available' } : { label: 'Expired', tone: 'failed' };
};
